import { useQuery } from '@tanstack/react-query';
import schema from '@/schemas/country-configuration';

import useStore, {
  selectFavoriteCountryId,
  selectSetSelectedCountry,
  selectSetCountryName,
  selectSetCountryId,
  selectSetCountryTheme,
  selectSetSiteUrl,
  selectSetContact,
  selectSetBrand,
  selectSetExampleBatch,
  selectSetDaysForDistribution,
} from '../client/useStore';

const parseData = (res) => {
  const parseResult = schema.safeParse(res);
  if (parseResult.success) {
    return parseResult.data;
  } else {
    console.log({ CountryConfigurations: parseResult?.error.issues });
    return null;
  }
};

const useCountryConfigurations = () => {
  const favoriteCountryId = useStore(selectFavoriteCountryId);
  const setSelectedCountry = useStore(selectSetSelectedCountry);
  const setCountryName = useStore(selectSetCountryName);
  const setCountryId = useStore(selectSetCountryId);
  const setCountryTheme = useStore(selectSetCountryTheme);
  const setSiteUrl = useStore(selectSetSiteUrl);
  const setContact = useStore(selectSetContact);
  const setBrand = useStore(selectSetBrand);
  const setExampleBatch = useStore(selectSetExampleBatch);
  const setDaysForDistribution = useStore(selectSetDaysForDistribution);

  return useQuery({
    queryKey: ['country-configurations', `country-${favoriteCountryId}`],
    queryFn: async () => {
      const response = await fetch(`/data/${favoriteCountryId}/base.json`);
      if (!response.ok) {
        throw new Error(`No se pudo cargar el archivo tema.`);
      }
      const res = await response.json();
      const parseResult = parseData(res);

      // set data to the state
      if (parseResult) {
        setSelectedCountry(parseResult);

        if (parseResult?.name && parseResult?.demonym) {
          setCountryName({ name: parseResult.name, demonym: parseResult.demonym });
        }

        if (parseResult?.countryId) {
          setCountryId(parseResult.countryId);
        }

        if (parseResult?.siteUrl) {
          setSiteUrl(parseResult.siteUrl);
        }

        if (parseResult?.contact) {
          setContact({
            ...parseResult.contact,
            facebookUrl: parseResult.facebook,
            instagramUrl: parseResult.instagram,
          });
        }

        if (parseResult?.brand) {
          setBrand(parseResult.brand);
        }

        if (parseResult?.theme) {
          setCountryTheme(parseResult.theme);
        }

        if (parseResult?.exampleBatch) {
          setExampleBatch(parseResult.exampleBatch);
        }

        if (parseResult?.daysForDistribution) {
          setDaysForDistribution(parseResult.daysForDistribution);
        }

        return parseResult;
      }
      return null;
    },
    retry: 1,
    enabled: !!favoriteCountryId, // fire this only if we have a defined favoriteCountryId
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};

export default useCountryConfigurations;
